"use client";

import styles from './MyProfileHeroSection.module.scss';
import Image from 'next/image';
import { MyProfileHeroSectionDataProps } from './MyProfileHeroSection.data';
import assetLoader from '@utils/internalImageLoder';
import MyProfileHeroSlider from '@components/molecules/MyProfileHeroSlider';
import VideoModalWrapper from '@components/molecules/VideoModalWrapper';
import Button from '@components/atoms/Button';
import { setClientCookie } from '@lib/cookies.client';

interface MyProfileHeroSectionProps {
  data: MyProfileHeroSectionDataProps;
  isLoggedIn: boolean;
  cityName: string;
}

const MyProfileHeroSection: React.FC<MyProfileHeroSectionProps> = ({
  data,
  isLoggedIn,
  cityName,
}) => {
  setClientCookie("oldBuyFlow", "true", { maxAge: 60 * 60 * 24 * 30 });
  const { heroSection } = data;

  const metaData = {
    authorName: "ACKO DRIVE",
    authorType: "ACKO DRIVE",
    duration: "127",
    mediaSource: "S3",
    primaryText: "Your car journey with expert support",
    secondaryText: "",
    thumbnail: "https://ackodrive-assets.s3.ap-south-1.amazonaws.com/video/tata/tiago-ev/default/thumbnail/tata-tiago-pro-and-cons-final_1.png",
    title: "Your car journey with expert support",
  };

  const videoUrl = "https://ackodrive-prod.ackoassets.com/video/generic/Acko+drive+2.0+-+Positioning+Video.mp4";

  return (
    <>

        {/* <div className={styles.TOTM_Container}>
          <Image 
            src={`${assetLoader()}/images/${isMobile ? 'TOTM_BG_Mobile' : 'TOTM_BG_Desktop'}.webp`}
            alt="TOTM Background"
            className={styles.TOTM_BG_Image}
            fill
            sizes="100vw"
            fetchPriority='high'
          />
          <Image 
            src={`${assetLoader()}/images/TOTM_Logo.webp`}
            alt="TOTM Logo"
            className={styles.TOTM_Logo}
            fill
            fetchPriority='high'
          />

          <Text className={styles.TOTM_Heading_Mobile}>{isMobile ? "2025 ACKO Drive Awards is here!" : "The Biggest Automobile Award is here!" }</Text>
          <Text className={styles.TOTM_SubHeading}>Vote for your favourite car and bike</Text>

          <Button 
            className={styles.TOTM_Button}
            onClick={() => router.push('https://ackodrive.com/awards')}
          >
            Vote now
          </Button>
          
        </div> */}

        {isLoggedIn ? (
          <div className={styles.container}>
          <section className={styles.heroSection}>
            {heroSection?.image1 && (
              <Image
                src={`${assetLoader()}${heroSection.image1.src}`}
                alt={`${heroSection.image1.alt}`}
                className={styles.heroImage}
                fill
                priority
              />
            )}
            <div className={styles.heroContent}>
              <h1 className={styles.heroTitle}>
                Welcome to your ACKO Drive account
              </h1>
              <p className={styles.heroSubHeader}>{heroSection.subHeader}</p>
              <VideoModalWrapper cityName={cityName} metaData={metaData} videoUrl={videoUrl}>
                <Button className={styles.heroCtaButton}>
                    <Image
                      src={`${assetLoader()}/icons/play-icon.svg`}
                      alt='Play'
                      height='28'
                      width='28'
                      priority
                    />
                  {heroSection.ctaText}
                </Button>
              </VideoModalWrapper>
            </div>
    
            {heroSection?.image2 && (
              <Image
                src={`${assetLoader()}${heroSection.image2.src}`}
                alt={`${heroSection.image2.alt}`}
                className={styles.heroImage}
                fill
                priority
              />
            )}

            {heroSection?.backgroundImage && (
              <Image 
                src={`${assetLoader()}${heroSection.backgroundImage.src}`}
                alt={heroSection.backgroundImage.alt}
                fill
                priority
                className={styles.MyProfileBGGridImage}
              />
            )}
          </section>
        </div>
      ) : (
        <MyProfileHeroSlider cityName={cityName} />
      )}
    </>
  );
};

export default MyProfileHeroSection;